<template>
    <div class="notifications-container" @click="setHmt('顶部导航_点击【消息通知】')">
        <div id="component147852"></div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
    components: {},
    props: {},
    data() {
        return {
            show: false,
            bixiContainer: null,
            step: 0,
        };
    },
    computed: {},
    watch: {
        step(value) {
            if (value === 2) {
                setTimeout(() => {
                    this.showMethods();
                }, 2500);
            }
        },
    },

    mounted() {
        this.$ajax
            .get('/api/tiktok/User/GetMcToken', {
                params: {},
            })
            .then((res) => {
                console.log(res);
                this.$nextTick(() => {
                    const ele = document.getElementById('component147852');
                    // window.ecopen.bixi(ele, {
                    //     token: 'CgwIARCtHBiqICABKAESTgpMcnWVA8mw1OffgkAA/ntKvh/F/HkQd3s8KQWlbytfIeTEMrewuVtc13xpUPlxkHqFe8kMw8958FPthXinosyvN+8bVjuXEJykwb2aQxoA',
                    //     componentId: 317,
                    //     shopId: '133841616',
                    // });
                    this.bixiContainer = window.ecopen.bixi(ele, {
                        token: res.result.token,
                        componentId: 317,
                        shopId: res.result.shopId,
                    });
                    this.step += 1;
                });
            });
    },
    methods: {
        showMethods() {
            if (this.bixiContainer && typeof this.bixiContainer.show === 'function') {
                let date = localStorage.getItem('component147852');
                let nowDate = dayjs().format('YYYY-MM-DD');
                if (date === nowDate) {
                    return;
                }
                let dom = document.querySelector('#component147852 .op_component_message_content');
                if (dom) {
                    let innerHTML = document.querySelector('#component147852 .op_component_message_content').innerHTML;
                    if (innerHTML - 0 > 0) {
                        localStorage.setItem('component147852', nowDate);
                        this.step = 0;
                        this.bixiContainer.show();
                    }
                }
            }
        },
        showContainer() {
            this.step += 1;
        },
    },
};
</script>

<style lang="scss" scoped>
.notifications-container {
    padding-top: 6px;
    margin-right: 20px;
    /deep/ .op_component_base_container {
        color: #fff;
    }
}
</style>
